import { Ds } from "@accurx/design";
import styled from "styled-components";

export const MessageContainer = styled(Ds.Flex).attrs({
    flexDirection: "column",
})`
    border: 1px solid var(--ds-color-silver);
    border-radius: var(--ds-border-radius);
`;

export const MessageHeader = styled.div`
    padding: 0.5rem;
    border-bottom: 1px solid var(--ds-color-silver);
`;

export const MessageBody = styled(Ds.Flex).attrs({
    flexDirection: "column",
    gap: "2",
})`
    padding: 1rem;
`;
